import React from 'react'
import ReactMarkdown from 'react-markdown'
import PropTypes from 'prop-types'
import { useTheme } from '../../context/themeContext'

export const EventualityBanner = ({ bannerData }) => {
  const { theme } = useTheme()
  
  return (
    <div className="mt-5 mb-5 w-100 h-100 d-flex flex-wrap flex-sm-wrap  flex-md-nowrap font-secondary">
      {bannerData.image?.url ? (
        <div
          role="img"
          alt=""
          className="w-100 min-height-100 eventuality-banner-image"
          style={{
            backgroundImage: `url(${bannerData.image.url})`
          }}
        ></div>
      ) : null}
      <div
        role="img"
        alt={bannerData.imageDescription || ''}
        className={`min-height-100 w-100 d-flex flex-column ${
          bannerData?.image?.url
            ? 'align-items-start banner-content'
            : 'align-items-center py-5'
        }  justify-content-center bg-eventuality-banner-content font-primary `}
        style={{
          backgroundImage: bannerData?.image?.url
            ? `url(${bannerData.image.url})`
            : '',
          backgroundSize: `cover` 
        }}
      >
        <div style={{
          backgroundImage: theme === 'dark' 
            ? 'linear-gradient(rgba(37, 67, 111, 0.49), rgba(0, 0, 0, 0.49))' 
            : undefined,
          backgroundColor: theme === 'light' 
          ? 'rgba(255, 255, 255, 0.5)' 
          : undefined,
        }}>
          <div className={`${bannerData?.image?.url ? 'pl-3' : ''}`}>
            <h2 className="font-weight-bold text-uppercase">
              {bannerData.title}
            </h2>
            <ReactMarkdown
              className="font-weight-bolder"
              source={bannerData.content}
            />
            {bannerData.url ? (
              <a
                href={bannerData.url}
                target="_blank"
                className="btn rounded-pill font-secondary font-weight-medium bg-eventuality-button border-ucc-boton text-white px-4"
                rel="noreferrer"
              >
                VER MÁS
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

EventualityBanner.propTypes = {
  bannerData: PropTypes.object.isRequired
}
